// Add your JS customizations here

/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.scrollY;
window.onscroll = function () {

	var currentScrollPos = window.scrollY;

	if (currentScrollPos > 90) {
		if (prevScrollpos > currentScrollPos) {
			document.getElementById("wrapper-navbar").style.top = "0";
		} else {
			document.getElementById("wrapper-navbar").style.top = "-200px";
		}
		prevScrollpos = currentScrollPos;
	}

}

// Prevent large accordions from scrolling the page
/*
jQuery(function ($) {
	$('.accordion-header').each(function () {
		let $card_header = $(this);
		let $collapse_element = $card_header.next();
		$collapse_element.on('show.bs.collapse', function () {
			let $card_header_top = $card_header.offset().top;
			let $visible_collapse = $('.collapse.show');
			if ($visible_collapse.length) {
				let $visible_collapse_top = $visible_collapse.offset().top;
				if ($visible_collapse_top < $card_header_top) {
					$card_header_top -= $visible_collapse.height();
				}
			}
			$([document.documentElement, document.body]).animate({
				scrollTop: $card_header_top - 200
			});
		});
	});
});
*/


// MEGAMENU customizations
jQuery(function ($) {

	// MEGAMENU customizations
	// close mobile sub-menus when you close the top level menu
	jQuery('.mega-menu-toggle').on('click', function (e) {
		jQuery('.max-mega-menu').data('maxmegamenu').hideAllPanels();

	});


	// For our custom translation buttons - we have two sets out of sync
	jQuery('.glink').on('click', function (e) {

		if ($(this).parent().hasClass("top-menu-en")) {
			$("li.mobile-menu-en > a").addClass("gt-current-lang");
			$("li.mobile-menu-fr > a").removeClass("gt-current-lang");
		}
		if ($(this).parent().hasClass("top-menu-fr")) {
			$("li.mobile-menu-fr > a").addClass("gt-current-lang");
			$("li.mobile-menu-en > a").removeClass("gt-current-lang");
		}
		if ($(this).parent().hasClass("mobile-menu-en")) {
			$("li.top-menu-en > a").addClass("gt-current-lang");
			$("li.top-menu-fr > a").removeClass("gt-current-lang");
		}
		if ($(this).parent().hasClass("mobile-menu-fr")) {
			$("li.top-menu-fr > a").addClass("gt-current-lang");
			$("li.top-menu-en > a").removeClass("gt-current-lang");
		}


	});

	// auto-link generator
	if ($('.page-links-section').length > 0) {

		var $links = $();
		//your code here
		$('h2').each(function (index, h2) {
			// If there is no id (to link to), create one based on the index
			if (!h2.id) {
				h2.id = 'header' + index;
			}

			// Get a jQuery object of the header
			var $h2 = $(h2);
			// Link will be an <a> with the same text as the heading, and will link to its id
			var $link = $('<a class="btn page-links-btn">').text($h2.text()).attr('href', '#' + h2.id);

			// Add this link to the collection
			$links = $links.add($link);
		});
		$links.insertAfter('.page-links-row');
	}


	// carousel stuff using accessible-slick!
	// note, don't append buttons to container outside of the parent .slick-accessible-slider,
	// or they will control all sliders on a page
	// let them auto-generate 'within' each parent div and they will be unique to their parent class
	$(document).ready(function () {
		var $themePath = $(location).attr('origin');
		$themePath = $themePath + '/wp-content/themes/stepstones/theme-images/';

		$('.slick-accessible-slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 600,
			arrowsPlacement: 'beforeSlides',
			arrows: true,
			prevArrow: "<button class='slick-prev' ><img class='a-left control-c prev slick-prev-icon' src='" + $themePath + "prev_icon.png'></button>",
			nextArrow: "<button class='slick-next' ><img class='a-right control-c next slick-next-icon' src='" + $themePath + "next_icon.png'></button>",
			responsive: [{

				breakpoint: 800,
				settings: {
					slidesToShow: 1

				}

			}]

		});
	});

	// PDF Slider
	$(document).ready(function () {
		var $themePath = $(location).attr('origin');
		$themePath = $themePath + '/wp-content/themes/stepstones/theme-images/';

		$('.slick-accessible-slider-pdf').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			//useTransform: true,
			//cssEase: 'ease-in-out',
			//speed:1000,
			arrowsPlacement: 'beforeSlides',
			arrows: true,
			prevArrow: "<button class='slick-prev' ><img class='a-left control-c prev slick-prev-icon' src='" + $themePath + "prev_icon.png'></button>",
			nextArrow: "<button class='slick-next' ><img class='a-right control-c next slick-next-icon' src='" + $themePath + "next_icon.png'></button>",
			responsive: [
				{
					breakpoint: 980,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}
			]

		});
	});
	// Home page Slider
	$(document).ready(function () {
		var $themePath = $(location).attr('origin');
		$themePath = $themePath + '/wp-content/themes/stepstones/theme-images/';

		$('.slick-accessible-slider-home').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 1000,
			arrowsPlacement: 'afterSlides',
			arrows: true,
			prevArrow: "<button class='slick-prev' ><img class='a-left control-c prev slick-prev-icon' src='" + $themePath + "prev_icon.png'></button>",
			nextArrow: "<button class='slick-next' ><img class='a-right control-c next slick-next-icon' src='" + $themePath + "next_icon.png'></button>",


		});
	});

	// home page statistics slider
	$(document).ready(function () {
		var $themePath = $(location).attr('origin');
		$themePath = $themePath + '/wp-content/themes/stepstones/theme-images/';

		$('.slick-accessible-slider-statistics').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			useTransform: true,
			cssEase: 'ease-in-out',
			speed: 1000,
			arrowsPlacement: 'beforeSlides',
			appendArrows: $(".statistics-slider-nav"),
			arrows: true,
			prevArrow: "<button class='slick-prev' ><img class='a-left control-c prev slick-prev-icon' src='" + $themePath + "prev_icon.png'></button>",
			nextArrow: "<button class='slick-next' ><img class='a-right control-c next slick-next-icon' src='" + $themePath + "next_icon.png'></button>",


		});
	});

	// statistics counter - to count up numbers on scroll
	$(".count").each(function () {
		$(this)
			.prop("Counter", 0)
			.animate(
				{
					Counter: $(this).text(),
				},
				{
					duration: 4000,
					easing: "swing",
					step: function (now) {
						now = Number(Math.ceil(now)).toLocaleString('en');
						$(this).text(now);
					},
				}
			);
	});


});
// google translate custom switcher

